export default "__VITE_ASSET__DBQEPMor__"